import { sameAddress } from '@/helpers/addresses';
import type { Token } from '@/references/tokens';

export const sameToken = (tokenA: Token, tokenB: Token): boolean => {
  return sameAddress(tokenA.address, tokenB.address) && tokenA.network === tokenB.network;
};
